var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { ActivatedRoute, Router } from '@angular/router';
import { ApiService } from '../../api.service';
import { CommonService } from '../../common.service';
import { ItemComponent } from "../../app-exercise-work/exercise-work-item/item.component";
var LearningCampResponseComponent = (function () {
    function LearningCampResponseComponent(route, apiService, commonService, router) {
        this.route = route;
        this.apiService = apiService;
        this.commonService = commonService;
        this.router = router;
        this.className = 'response';
        this.tabNum = 0;
        this.isElseTeacherEvaluate = true; //学员作答是否有顾问点评
        this.myComment = ""; //我的作答顾问第一次点评
        this.myQuetionComment = ""; //我的作答顾问第二次点评
        this.submitAt = ""; //学员提交时间
        this.isComment = false; //是否有评论
        this.studentList = null; //学员作答
        this.myData = null; //我的作答
        this.isOpenClass = 0; //是否公开课
        this.selectedTag = "";
        this.collapse = true;
        this.relationIdArr = []; //学员作答relationId
        this.answerGroup = []; //学员作答答案
        this.isStudet = true;
        this.isCollapse = true;
        this.theme = 'sight';
        this.appreciateList = [];
        this.isShowToast = false;
        this.destext = "您已经点过赞了";
        this.isOpen = 0;
        this.data = {};
        this.showCount = false; //在自己没点赞情况下展示点赞次数(大于0展示)
        this.ifshowData = false;
        this.isOnlyCamp = false; //只有训练营
        this.isLastDay = false; //是否是day7
        this.uploadId = ""; //查询上传文件条件
        this.isShowPreview = false; //是否显示预览
        this.text = "";
        this.isShowBackDesc = false; //是否展示背景描述
        this.homeworkCloseAtFlag = 0; //作答时间是否截止
        this.homeworkNoAnswer = 0; //作业是否未作答
        this.campId = 0;
    }
    LearningCampResponseComponent.prototype.ngOnInit = function () {
        var _this = this;
        console.log('进入作答展示');
        this.isOpenClass = Number(localStorage.getItem('openClass')) ? 1 : 0;
        this.tabList = ['我的作答', '学员作答'];
        this.campId = Number(localStorage.getItem("campId")) ? Number(localStorage.getItem("campId")) : 0;
        this.route.queryParams.subscribe(function (queryParams) {
            _this.tabNum = queryParams['tabNum'];
            _this.constituteId = queryParams['constituteId'];
            _this.isOnlyCamp = !!queryParams['onlyCamp'];
            _this.back = !!queryParams['back'];
            _this.relationId = queryParams['relationId'];
            _this.comment = queryParams['comment'];
            _this.commentFlag = queryParams['commentFlag'];
            _this.learningPathId = queryParams['learningPathId'];
            _this.courseId = queryParams['courseId'];
            _this.isFirstDay = !!queryParams['firstDay'];
            _this.isLastDay = !!queryParams['isLastDay'];
            _this.projectId = queryParams['projectId'];
            _this.courseLearningPathMetaId = queryParams['courseLearningPathMetaId'];
            _this.homeworkCloseAtFlag = Number(queryParams['homeworkCloseAtFlag']);
        });
        this.apiService.learingTime({ learningPathMetaId: Number(localStorage.getItem("learningPathMetaId")),
            module: "作业",
            type: 1,
            courseUnit: Number(this.constituteId),
            btnName: '作业作答展示',
            userId: localStorage.getItem('userId') })
            .subscribe(function (result) { });
        //我的作答答题数据
        var questionGroup = [];
        this.getExerciseDetail(this.constituteId).then(function (result) {
            _this.exerciseGroup = result;
            _this.homeworkNoAnswer = _this.exerciseGroup.status <= 10 ? 0 : 1;
            if (_this.exerciseGroup.questionGroup[0].type == 1) {
                _this.exerciseGroup.questionGroup[0].str = _this.exerciseGroup.questionGroup[0].answers;
            }
            _this.page = 'list';
            //消息通知外链进入
            if (result['campMetaId']) {
                localStorage.setItem("campId", result['campMetaId']);
            }
            if (result['projectId']) {
                localStorage.setItem("skuId", result['projectId']);
            }
            if (result['isOnlyCamp']) {
                localStorage.setItem("onlyCamp", result['isOnlyCamp']);
            }
            _this.getLearningPathMetaId();
        }).catch(function (err) {
            if (err.status === 401) {
                _this.router.navigate(['new-login']);
            }
        });
        //获取交互数据
        this.getData();
    };
    LearningCampResponseComponent.prototype.ngOnDestroy = function () {
        console.log('离开作答展示');
        this.apiService.learingTime({ learningPathMetaId: Number(localStorage.getItem("learningPathMetaId")),
            module: "作业",
            type: 2,
            courseUnit: Number(this.constituteId),
            btnName: '作业作答展示',
            userId: localStorage.getItem('userId') })
            .subscribe(function (result) { });
    };
    LearningCampResponseComponent.prototype.getData = function () {
        var _this = this;
        //获取我的作答数据
        this.getMyAnswerEvaluate(this.constituteId).then(function (result) {
            _this.myData = result;
            _this.myRelationId = result.relationId;
            _this.myComment = result.comment;
            _this.myQuetionComment = result.questioningComment;
            _this.excellentFlag = result.excellentFlag;
            if (result.appreciateCount > 0) {
                _this.showCount = true;
            }
            //我的作答评论返回(保存评论)
            if (_this.tabNum == 0 && _this.comment && _this.back) {
                if (_this.myData.relationId == _this.relationId) {
                    _this.myData.myComment = _this.comment;
                }
            }
        }).then(function () {
            var arr = [];
            // 获取学员作答数据
            return _this.getStudentAnswers(_this.constituteId).then(function (result) {
                //筛选出除了单选题其他答案(实战作业第一题为单选题需要展示出来)
                if (!_this.isLastDay) {
                    arr = result['studentAnswerVOList'].map(function (item) {
                        return item['campExerciseQuestionGroupMetaVO'].questionGroup.filter(function (questionItem) { return questionItem.type !== 2; });
                    });
                }
                //智能作业筛选出除了多选题其他答案（不包含训练营）
                if (_this.exerciseGroup.workSource != "camp") {
                    arr = JSON.parse(JSON.stringify(arr)).map(function (item) {
                        return item.filter(function (questionItem) { return questionItem.type !== 4; });
                    });
                }
                //重新赋值
                if (!_this.isLastDay) {
                    for (var i = 0; i < result['studentAnswerVOList'].length; i++) {
                        result['studentAnswerVOList'][i]['campExerciseQuestionGroupMetaVO'].questionGroup = arr[i];
                    }
                    return _this.studentList = result['studentAnswerVOList'].length > 0 ? result['studentAnswerVOList'] : [];
                }
                else {
                    return _this.studentList = result['studentAnswerVOList'];
                }
            });
        }).then(function () {
            // 请求查看所有的点赞数据
            return _this.getAppreciate().then(function (result) {
                return _this.appreciateList = result;
            });
        }).then(function () {
            var self = _this;
            self.getAnswerUploadList(Number(self.tabNum));
            (_a = self.answerGroup).push.apply(_a, self.studentList.map(function (item) { return item.campExerciseQuestionGroupMetaVO; }));
            (_b = self.relationIdArr).push.apply(_b, self.answerGroup.map(function (item) { return item.relationId; }));
            _this.studentList.forEach(function (item) {
                item.userClick = false;
                if (item['campExerciseQuestionGroupMetaVO'].questionGroup.length > 0 && (item['campExerciseQuestionGroupMetaVO'].questionGroup[0].type == 1 || item['campExerciseQuestionGroupMetaVO'].questionGroup[0].type == 7)) {
                    item['campExerciseQuestionGroupMetaVO'].questionGroup[0].str = item['campExerciseQuestionGroupMetaVO'].questionGroup[0].answers;
                }
            });
            //学员作答评论返回(保存评论)
            if (_this.tabNum == 1 && _this.comment && _this.back) {
                self.studentList.forEach(function (item) {
                    if (item['userCampExerciseQuestionOperationLogVO'].relationId == _this.relationId) {
                        item['userCampExerciseQuestionOperationLogVO'].Studentcomment = _this.comment;
                    }
                });
            }
            self.myData.userClick = false;
            self.myData.showOpen = 0;
            //我的作答是否点赞判断
            self.appreciateList.forEach(function (item) {
                if (item.userCampExerciseQuestionGroupMetasRelationId == self.myData.relationId) {
                    self.myData.userClick = true;
                }
            });
            _this.studentList.forEach(function (item) {
                item.userClick = false;
                item.showCount = false;
                item.showOpen = 0;
                item['userCampExerciseQuestionOperationLogVO'].commentCount = 0;
                if (item['userCampExerciseQuestionOperationLogVO'].appreciateCount > 0) {
                    item.showCount = true;
                }
                if (item['userCampExerciseQuestionOperationLogVO'].studentCommentList == null) {
                    item['userCampExerciseQuestionOperationLogVO'].commentCount = 0;
                }
                else {
                    item['userCampExerciseQuestionOperationLogVO'].commentCount = item['userCampExerciseQuestionOperationLogVO'].studentCommentList.length;
                }
                //学员作答点赞情况判断
                self.appreciateList.forEach(function (itm) {
                    if (item['userCampExerciseQuestionOperationLogVO'].relationId == itm.userCampExerciseQuestionGroupMetasRelationId) {
                        item.userClick = true;
                    }
                });
            });
            setTimeout(function () {
                _this.judjeHeight();
            }, 100);
            //所有数据是否请求完毕才展示页面
            if (_this.studentList || _this.myData) {
                _this.ifshowData = true;
            }
            var _a, _b;
        });
    };
    //背景描述
    LearningCampResponseComponent.prototype.backgroundDesc = function () {
        this.isShowBackDesc = !this.isShowBackDesc;
    };
    LearningCampResponseComponent.prototype.getLearningPathMetaId = function () {
        //根据LearningPathMetaId判断获取是第几单元为了外链进入到作答页面后返回课程列表页是第几单元
        if (this.isFirstDay) {
            if (this.campId === 1 || this.campId === 3) {
                localStorage.setItem("campCourseDay", "Start Day");
            }
            else {
                localStorage.setItem("campCourseDay", "Day1");
            }
        }
        else if (this.isLastDay) {
            if (this.campId === 1) {
                localStorage.setItem("campCourseDay", "综合检测");
                localStorage.setItem("learningPathMetasId", "-49601");
            }
            else if (this.campId === 3) {
                localStorage.setItem("campCourseDay", "综合检测");
                localStorage.setItem("learningPathMetasId", "-429601");
            }
            else {
                localStorage.setItem("campCourseDay", "Day14");
                localStorage.setItem("learningPathMetasId", "-419601");
            }
        }
        else {
            if (this.learningPathId) {
                this.apiService.ajax({
                    'type': 'get',
                    'url': '/ddilearner/v1/getLearningPathMetaId/' + this.learningPathId
                }).subscribe(function (result) {
                    switch (result.data) {
                        case 4192:
                            localStorage.setItem("campCourseDay", "Day2&3");
                            break;
                        case 492 || 4292:
                            localStorage.setItem("campCourseDay", "沟通原则");
                            break;
                        case 412:
                            localStorage.setItem("campCourseDay", "Day4&5");
                            break;
                        case 402 || 422:
                            localStorage.setItem("campCourseDay", "互动流程");
                            break;
                        case 416:
                            localStorage.setItem("campCourseDay", "Day6&7");
                            break;
                        case 406 || 426:
                            localStorage.setItem("campCourseDay", "目标设定");
                            break;
                        case 413:
                            localStorage.setItem("campCourseDay", "Day8&9");
                            break;
                        case 403 || 423:
                            localStorage.setItem("campCourseDay", "任务授权");
                            break;
                        case 415:
                            localStorage.setItem("campCourseDay", "Day10&11");
                            break;
                        case 405 || 425:
                            localStorage.setItem("campCourseDay", "辅导他人");
                            break;
                        case 4196:
                            localStorage.setItem("campCourseDay", "Day12&13");
                            break;
                        case 496 || 4296:
                            localStorage.setItem("campCourseDay", "绩效追踪");
                            break;
                    }
                });
            }
        }
    };
    LearningCampResponseComponent.prototype.ngAfterViewInit = function () {
        this.commonService.initPage({
            'backgroundColor': 'rgba(40,51,130,1)'
        });
    };
    /**
     * 获取答题界面用户上传列表
     * @param tabNum: Number  nav下标
     */
    LearningCampResponseComponent.prototype.getAnswerUploadList = function (tabNum) {
        var _this = this;
        if (tabNum === 0) {
            var index = this.commonService.getIndexByConditionIdInLists(this.exerciseGroup['questionGroup'], 'type', 5);
            if (index >= 0) {
                this.uploadId = this.exerciseGroup['questionGroup'][index]['campFileUploadIds'] ? this.exerciseGroup['questionGroup'][index]['campFileUploadIds'] : '';
                this.getCampFile({ 'constituteId': this.constituteId, 'questionId': this.exerciseGroup['questionGroup'][index]['questionId'], 'campFileUploadIds': this.uploadId }).then(function (result) {
                    _this.uploadList = result['newFileList'];
                });
            }
            else {
                this.uploadList = [];
            }
        }
    };
    LearningCampResponseComponent.prototype.tabIndex = function (i) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.ifshowData = false;
                        this.tabNum = i;
                        if (this.tabNum == 0) {
                            this.getAnswerUploadList(this.tabNum);
                        }
                        return [4 /*yield*/, this.getData()];
                    case 1:
                        _a.sent();
                        //切换tab时滚动到顶部
                        $('.wrap').scrollTop(0);
                        return [2 /*return*/];
                }
            });
        });
    };
    //判断高度是否达到可展开收拢高度
    LearningCampResponseComponent.prototype.judjeHeight = function () {
        if (this.tabNum == 0) {
            var exerciseWorkBox = document.getElementById("exercise-work-box-" + this.myRelationId);
            if (this.myData.comment != '' && this.myData.comment != null && exerciseWorkBox && exerciseWorkBox.offsetHeight > 220) {
                this.myData.showOpen = 1;
            }
        }
        else if (this.tabNum == 1) {
            this.studentList.forEach(function (item) {
                // 有评论且高度达到
                var exerciseWorkBox = document.getElementById("exercise-work-box-" + item['userCampExerciseQuestionOperationLogVO'].relationId);
                if (item['userCampExerciseQuestionOperationLogVO'].comment != "" && item['userCampExerciseQuestionOperationLogVO'].comment != null && exerciseWorkBox && exerciseWorkBox.offsetHeight > 200) {
                    item.showOpen = 1;
                }
            });
        }
    };
    //我的作答大展开
    LearningCampResponseComponent.prototype.myOpen = function (flag) {
        this.myData.showOpen = flag == 1 ? 2 : 1;
        //点击收拢的时候回到顶部
        if (this.myData.showOpen == 1) {
            //跳转到对应位置
            var ele = document.querySelector(".my");
            ele.scrollTop = 0;
        }
    };
    LearningCampResponseComponent.prototype.studentOpen = function (relationId) {
        this.studentList.map(function (item) {
            if (item['userCampExerciseQuestionOperationLogVO'].relationId == relationId) {
                item.showOpen = item.showOpen == 1 ? 2 : 1;
            }
        });
        //跳转到对应位置
        var ele = document.querySelector(".comment_wrap-" + relationId);
        ele.scrollIntoView();
    };
    //获取收拢展开
    LearningCampResponseComponent.prototype.getIsCollapse = function (event) {
        this.isCollapse = event;
    };
    //返回
    LearningCampResponseComponent.prototype.exit = function () {
        var learningPathId = null;
        var courseId = null;
        this.route.queryParams.subscribe(function (queryParams) {
            learningPathId = queryParams['learningPathId'];
            courseId = queryParams['courseId'];
        });
        if (this.isLastDay) {
            //实战作业返回
            this.router.navigate(['course-new', learningPathId, courseId], { queryParams: { isLastDay: 1 } });
        }
        else if (this.isFirstDay) {
            this.router.navigate(['course-new', learningPathId, courseId], { queryParams: { firstDay: 1 } });
        }
        else {
            if (learningPathId && courseId) {
                this.router.navigate(['course-new', learningPathId, courseId]);
            }
            else {
                if (this.exerciseGroup.workSource == 'homework') {
                    localStorage.removeItem("skuId");
                    var link = [];
                    if (this.projectId) {
                        link = ['learning-project', this.projectId];
                    }
                    else if (this.courseLearningPathMetaId) {
                        localStorage.setItem("projectId", this.exerciseGroup.projectId);
                        link = ['learning-path', this.courseLearningPathMetaId];
                    }
                    this.router.navigate(link).then();
                }
                else {
                    this.router.navigate(['exercise-book']);
                }
            }
        }
    };
    LearningCampResponseComponent.prototype.setBodyHeight = function (event) {
        this.bodyHeight = event + 'rem';
    };
    //我的作答点赞
    LearningCampResponseComponent.prototype.getMyAppreciate = function () {
        // this.getMyAnswerEvaluate(this.constituteId).then(result => {
        //   this.myData = result
        //   this.myData.userClick = true
        // })
        this.myData.appreciateCount += 1;
        this.myData.userClick = true;
        //学员作答同一账号同步改变
        // this.studentList.forEach(item=>{
        //  if( item['userCampExerciseQuestionOperationLogVO'].relationId == this.myData.relationId){
        //    console.log(item['userCampExerciseQuestionOperationLogVO'].relationId)
        //    console.log(this.myData.relationId)
        //   item['userCampExerciseQuestionOperationLogVO'].appreciateCount = item['userCampExerciseQuestionOperationLogVO'].appreciateCount += 1
        //   item.userClick = true
        //  }
        // })
    };
    //学员点赞
    LearningCampResponseComponent.prototype.getStudentAppreciate = function (obj) {
        // this.data.relationId = obj.relationId
        // this.data.type = "appreciate"
        // this.giveAppreciate(this.data).then(()=>{
        //   //判断学员点赞和我的作答点赞是否是同一个账号(两边效果同步)
        //   if(obj.relationId == this.myData.relationId){
        //     console.log("我点过赞了")
        //     this.myData.userClick = true
        //     this.myData.appreciateCount +=1
        //   }
        // })
        obj.studentList.map(function (item) {
            if (item['campExerciseQuestionGroupMetaVO'].relationId == obj.relationId) {
                item['userCampExerciseQuestionOperationLogVO'].appreciateCount = item['userCampExerciseQuestionOperationLogVO'].appreciateCount += 1;
                item.userClick = true;
            }
        });
        this.studentList = obj.studentList;
    };
    LearningCampResponseComponent.prototype.getShowToast = function (flag) {
        var _this = this;
        this.isShowToast = flag;
        if (this.isShowToast) {
            setTimeout(function () {
                _this.isShowToast = false;
            }, 2000);
        }
    };
    //点赞
    LearningCampResponseComponent.prototype.giveAppreciate = function (data) {
        return this.apiService.ajax({
            'type': 'post',
            'url': '/ddilearner/v2/camp/applicationPractice/saveOperationLog',
            'data': data
        }).toPromise();
    };
    //点赞列表
    LearningCampResponseComponent.prototype.getAppreciate = function () {
        return this.apiService.ajax({
            'type': 'get',
            'url': '/ddilearner/v2/camp/applicationPractice/getOperationLogList/3',
        }).toPromise();
    };
    //获取day7文件
    LearningCampResponseComponent.prototype.getCampFile = function (data) {
        return this.apiService.ajax({
            'type': 'POST',
            'url': '/ddilearner/v2/camp/applicationPractice/actualOperation/getCampFileList',
            'data': data
        }).toPromise();
    };
    //根据试卷ID获取当前试卷所有小题题目
    LearningCampResponseComponent.prototype.getExerciseDetail = function (lpmapcId) {
        return this.apiService.ajax({
            'type': 'GET',
            'url': 'ddilearner/v2/camp/applicationPractice/getQuestionGroup/' + lpmapcId,
        }).toPromise();
    };
    //获取我的作答数据
    LearningCampResponseComponent.prototype.getMyAnswerEvaluate = function (constituteId) {
        return this.apiService.ajax({
            'type': 'GET',
            'url': '/ddilearner/v2/camp/applicationPractice/getMyAnswer/' + constituteId
        }).toPromise();
    };
    //获取学员作答数据
    LearningCampResponseComponent.prototype.getStudentAnswers = function (constituteId) {
        return this.apiService.ajax({
            'type': 'GET',
            'url': '/ddilearner/v2/camp/applicationPractice/getStudentAnswerV2/' + constituteId
        }).toPromise();
    };
    /**
     * 预览
     * @param event:Object   子组件传递来的预览对象
     */
    LearningCampResponseComponent.prototype.showReview = function (event) {
        console.log(11111111111111);
        this.previewSource = event;
        this.isShowPreview = true;
    };
    /**
     * 关闭预览
     */
    LearningCampResponseComponent.prototype.closePreview = function () {
        this.isShowPreview = false;
    };
    return LearningCampResponseComponent;
}());
export { LearningCampResponseComponent };



// WEBPACK FOOTER //
// ./src/app/learning-camp/camp-response/learning-camp-response.component.ts.pre-build-optimizer.js